import React from 'react';

// helpers
import useTranslation from '../../../../../../hooks/useTranslation';
import { PasswordValidationSchema } from '../../../../../../validations/profile/auth';

// components
import InnerForm from './InnerForm';
import SubmitButton from '../../../../../Buttons/SubmitButton';
import { Form } from '@ui';

export interface FormValuesModel {
  password: string;
}

interface IProps {
  initialFormValues: FormValuesModel;
  handleSubmit: (values: FormValuesModel) => Promise<void>;
}

const SignInPasswordForm = ({ initialFormValues, handleSubmit }: IProps) => {
  const { t } = useTranslation('auth');

  return (
    <Form<FormValuesModel>
      onSubmit={handleSubmit}
      initialValues={initialFormValues}
      validationSchema={PasswordValidationSchema}
      renderForm={
        <>
          <InnerForm />
          <SubmitButton fullWidth type="primary">
            {t('signin.steps.signin.submit_button')}
          </SubmitButton>
        </>
      }
    />
  );
};

export default SignInPasswordForm;
